package com.essntl.features.contact.ui.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.fillMaxHeight
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.BasicAlertDialog
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import com.essntl.features.address.ui.AddressEvent
import com.essntl.features.address.ui.AddressState
import com.essntl.features.address.ui.AddressValidation
import com.essntl.features.contact.domain.model.ContactModel
import com.essntl.features.contact.ui.ContactEvent
import com.essntl.features.contact.ui.ContactScreen
import com.essntl.features.contact.ui.ContactState
import com.essntl.features.contact.ui.ContactValidation
import com.essntl.features.organization.domain.model.OrganizationModel
import com.essntl.uikit.components.iconbutton.outline.EsSmallOutlineIconButton
import com.essntl.uikit.components.icons.EsIcons
import com.essntl.uikit.components.utils.spacing
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun ContactDialog(
    state: ContactState,
    onEvent: (ContactEvent) -> Unit,
    validation: ContactValidation,
    contact: ContactModel? = null,
    addressState: AddressState,
    onAddressEvent: (AddressEvent) -> Unit,
    addressValidation: AddressValidation,
    organizationId: String?,
    isOpen: Boolean,
    onDismissRequest: () -> Unit,
) {
    LaunchedEffect(isOpen) {
        if (isOpen)
            organizationId?.let { id ->
                onEvent(
                    ContactEvent.UpdateContactFields(
                        ContactModel.empty.copy(
                            organization = OrganizationModel.empty.copy(
                                id = id,
                            ),
                        ),
                    ),
                )

                if (contact != null)
                    onEvent(ContactEvent.GetContact(contact.id))
            }
    }

    if (isOpen) {
        BasicAlertDialog(
            onDismissRequest = onDismissRequest,
            modifier = Modifier.fillMaxHeight(0.5f),
        ) {
            Box(
                modifier = Modifier
                    .fillMaxWidth()
                    .clip(RoundedCornerShape(25.dp)),
            ) {
                Column(
                    horizontalAlignment = Alignment.Start,
                    verticalArrangement = Arrangement.Center,
                    modifier = Modifier
                        .fillMaxWidth()
                        .background(color = Color.White),
                ) {
                    Box(
                        modifier = Modifier
                            .fillMaxWidth()
                            .background(color = MaterialTheme.esColorScheme.bgPrimary)
                            .padding(vertical = 3.spacing, horizontal = 2.5.spacing),
                    ) {
                        Text(
                            text = if (contact != null)
                                "Edit a Contact" else
                                "Add a Contact",
                            style = MaterialTheme.esTypography.h3Bold24,
                            color = MaterialTheme.esColorScheme.textPrimary,
                            modifier = Modifier.align(Alignment.CenterStart),
                        )

                        EsSmallOutlineIconButton(
                            onClick = {
                                onDismissRequest()
                            },
                            iconRes = EsIcons.Close,
                            modifier = Modifier.align(Alignment.CenterEnd),
                        )
                    }

                    ContactScreen(
                        state = state,
                        onEvent = onEvent,
                        validation = validation,
                        addressState = addressState,
                        onAddressEvent = onAddressEvent,
                        addressValidation = addressValidation,
                        dialog = true,
                    )
                }
            }
        }
    }
}